#import "~/graphql/fragments/CraftLink.graphql"

fragment ContentBlockAccordion on contentBlocks_accordion_BlockType {
    craftId: id
    title: sectionTitle

    accordion {
        ... on accordionItem_Entry {
            title: header
            content: text
        }
    }

    cta {
        ... CraftLink
    }

    anchorId
    anchorLabel
}
